// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1lCA-","consentsList":"PatientConsents_consentsList__23GAD","consentsListEmpty":"PatientConsents_consentsListEmpty__2BXjt"};